// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-bar-button[data-v-6f97496e] {\n  padding: 7px 16px;\n  border-radius: 10px;\n}\n.bg-yellow-100[data-v-6f97496e] {\n  background-color: #FFDA69;\n}\n.left-side-bar[data-v-6f97496e] {\n  max-width: 305px;\n}\n.left-side-bar-content[data-v-6f97496e] {\n  font-family: 'Outfit';\n  padding: 24px;\n  border-radius: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
